<template>
  <div>
    <v-row>
      <h1 class="ml-4">HqNames</h1>
    </v-row>

    <v-spacer></v-spacer>
    <v-card class="mt-3">
      <v-card-title>
        <v-text-field
          v-model="search"
          placeholder="Type an hqNames name to search..."
          outlined
          clearable
          counter
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="hqNames.records"
          :loading="isLoading"
          :search="search"
          transition="scale-transition"
          class="new-detault-table hqNames-view"
        >
          <template v-slot:top>
            <v-row class="card-slider mb-4" justify="center">
              <v-col cols="12" sm="4" md="4" lg="4">
                <download-excel
                  class="text-right"
                  :data="hqNames.records"
                  :fields="fields"
                  worksheet="HqNames"
                  name="CRMHqNameList.xls"
                >
                  <v-btn class="text-right" color="#0a2752" large dark>
                    <h1>Download</h1>
                  </v-btn>
                </download-excel>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="4">
                <v-btn
                  dark
                  color="primary"
                  large
                  @click="$router.push('/admin/hqName/0/edit')"
                  ><h1>Create new HqName</h1></v-btn
                >
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.createdAt="{ item }">
            <h3 color="primary">{{ item.createdAt | getFormattedDate }}</h3>
          </template>
          <template v-slot:item.updatedAt="{ item }">
            <h3 color="primary">{{ item.updatedAt | getFormattedDate }}</h3>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              fab
              x-small
              dark
              class="mr-2"
              @click="editItem(item)"
              color="primary"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              fab
              x-small
              dark
              class="ml-2"
              @click="deleteItem(item)"
              color="blue darken-2"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import defaultProfile from "../../../assets/img/avatar.png";
export default {
  components: { defaultProfile },
  data() {
    return {
      fields: {
        "HqName Name": "name",
        "HqName Id": "id",
        "Created At": "createdAt",
      },
      headers: [
        { text: "Name", align: "start", sortable: false, value: "name" },
        {
          text: "Telephone Number",
          align: "start",
          sortable: false,
          value: "telNumber",
        },
        { text: "Email", align: "start", sortable: false, value: "email" },
        { text: "Website", align: "start", sortable: false, value: "website" },
        {
          text: "Industry",
          align: "start",
          sortable: false,
          value: "industry",
        },
        { text: "Tags", align: "start", sortable: false, value: "tags" },
        {
          text: "Management Company",
          align: "start",
          sortable: false,
          value: "managementCompany",
        },
        { text: "Mandate", align: "start", sortable: false, value: "mandate" },
        { text: "notes", align: "start", sortable: false, value: "notes" },
        { text: "active", align: "start", sortable: false, value: "active" },
        { text: "Created Date", value: "createdAt" },
        { text: "Updated Date", value: "updatedAt" },
        { text: "Actions", align: "right", sortable: false, value: "actions" },
      ],
      search: "",
      hqNames: [],
      totalRecords: 0,
      isLoading: false,
    };
  },

  apollo: {
    hqNames: {
      query: gql`
        query HqNames($limit: Int!, $skip: Int!, $query: JSON!) {
          hqNames(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              name
              telNumber
              email
              website
              industries {
                name
              }
              tags {
                name
              }
              managementCompany
              mandate
              notes
              active
              createdAt
              updatedAt
            }
            count
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        const self = this;
        const limit = 9999;
        const skip = 0;
        return {
          limit: limit,
          skip: skip,
          query: {},
        };
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
    },
  },

  methods: {
    editItem(item) {
      this.$router.push(`/admin/hqName/${item.id}/edit`);
    },

    deleteItem(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
                mutation ($id: ID!) {
                  deleteHqName(id: $id) {
                    id
                    deleted
                  }
                }
              `,
              variables: {
                id: item.id,
              },
            });

            if (response) {
              this.$swal(
                "Success!",
                "HqName was successfully deleted",
                "success"
              );
              this.$router.go(this.$route.currentRoute);
            }
          } catch (e) {}
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
